module.exports = __webpack_public_path__ + "img/SKWINKELNetActieDraaiboek5FA7C4.732a616a.png";